import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { FashionAccessoriesPage } from './pages/FashionAccessoriesPage';
import { HomeAppliancesPage } from './pages/HomeAppliancesPage';
import { ElectronicsPage } from './pages/ElectronicsPage';
import { AboutPage } from './pages/AboutPage';
import { TrackOrderPage } from './pages/TrackOrderPage';
import { CheckoutPage } from './pages/CheckoutPage';
export type Page = 'home' | 'fashion' | 'appliances' | 'electronics' | 'about' | 'track-order' | 'checkout';
export interface CartItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  image: string;
  weight?: number;
}
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const navigate = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleAddToCart = (product: Omit<CartItem, 'quantity'>) => {
    setCartItems(prev => {
      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        return prev.map(item => item.id === product.id ? {
          ...item,
          quantity: item.quantity + 1
        } : item);
      }
      return [...prev, {
        ...product,
        quantity: 1
      }];
    });
    setIsCartOpen(true);
  };
  const handleUpdateQuantity = (id: string, delta: number) => {
    setCartItems(prev => prev.map(item => item.id === id ? {
      ...item,
      quantity: Math.max(1, item.quantity + delta)
    } : item));
  };
  const handleRemoveItem = (id: string) => {
    setCartItems(prev => prev.filter(item => item.id !== id));
  };
  const cartCount = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  const sharedProps = {
    onAddToCart: handleAddToCart,
    onNavigate: navigate,
    cartItems,
    cartCount,
    isCartOpen,
    onOpenCart: () => setIsCartOpen(true),
    onCloseCart: () => setIsCartOpen(false),
    onUpdateQuantity: handleUpdateQuantity,
    onRemoveItem: handleRemoveItem
  };
  switch (currentPage) {
    case 'fashion':
      return <FashionAccessoriesPage {...sharedProps} data-id="element-0" />;
    case 'appliances':
      return <HomeAppliancesPage {...sharedProps} data-id="element-1" />;
    case 'electronics':
      return <ElectronicsPage {...sharedProps} data-id="element-2" />;
    case 'about':
      return <AboutPage {...sharedProps} data-id="element-3" />;
    case 'track-order':
      return <TrackOrderPage {...sharedProps} data-id="element-4" />;
    case 'checkout':
      return <CheckoutPage {...sharedProps} data-id="element-5" />;
    default:
      return <HomePage {...sharedProps} data-id="element-6" />;
  }
}